import ajax from '../config/ajax'
import { getJSON } from './ultile'
import globalConfig from '../utiles/globalConfig'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    danaLogin({ rootState }, params) {
      return new Promise((resolve, reject) => {
        getJSON(ajax.dana.login.index, params).then(res => {
          console.log('dana login res', res)
          if (parseInt(res.res.result, 10) === 1) {
            try {
              globalConfig.gaStatistics('login_success', {
                login_type: 'dana'
              })
            } catch (e) { }
            resolve()
          } else {
            reject({ type: 'dana', msg: res.errmsg })
          }
        })
      })

    },
    danaBind({ rootState }, params) {
      return new Promise((resolve, reject) => {
        getJSON(ajax.dana.login.bind, params).then(res => {
          if (parseInt(res.res.result, 10) === 1) {
            try {
              globalConfig.gaStatistics('bind_account', {
                bindType: 'dana'
              })
            } catch (e) { }
            resolve()
          } else {
            reject({ type: 'dana', msg: res.errmsg })
          }
        })
      })

    },
  }
}
